import * as Sentry from "@sentry/react"
import { QueryClientProvider } from "@tanstack/react-query"
import { RouterProvider } from "@tanstack/react-router"

import { queryClient, router } from "./router"
import { ENV } from "./utilities/config"
import { useTheme } from "./utilities/hooks/useTheme"

const isProd = ENV === "production"

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: ENV,
  release: APP_VERSION,
  integrations: [
    Sentry.tanstackRouterBrowserTracingIntegration(router),
    Sentry.replayIntegration(),
    Sentry.breadcrumbsIntegration({
      console: false,
      dom: true,
      fetch: true,
      history: true,
      xhr: true,
    }),
  ],
  tracesSampleRate: isProd ? 0.1 : 1.0, // 10% in production, 100% otherwise
  replaysSessionSampleRate: isProd ? 0.1 : 1.0, // 10% in production, 100% otherwise
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

function App() {
  const { setScannedArea, setDocumentThemeMode } = useTheme()
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider
        router={router}
        context={{
          setScannedArea,
          setDocumentThemeMode,
        }}
      />
    </QueryClientProvider>
  )
}

export default App
